<div class="app-loading" *ngIf="loading">
    <div class="logo"></div>
    <svg class="spinner" viewBox="25 25 50 50">
        <circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10" />
    </svg>
</div>

<div class="main-content" *ngIf="!loading">
    <!-- <hubspot-ticket (answer)="getAnswer('ticketResponse', $event)" [seoUrl]="ticketSeoUrl" [ticket]="hubspotTicket">
    </hubspot-ticket> -->
    
    <div class="container-fluid">
        <div class="row" *ngIf="!tagModeOn">
            <div class="col-lg-3 col-sm-6">
                <div class="card">
                    <div class="card-content">
                        <div class="row">
                            <div class="col-xs-5">
                                <div class="icon-big icon-success text-center">
                                    <i class="ti-wallet"></i>
                                </div>
                            </div>
                            <div class="col-xs-7">
                                <div class="numbers">
                                    <p>Lojas Pagantes</p>
                                    {{ payingStores}}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card-footer">
                        <hr />
                        <div class="stats">
                            <i class="ti-calendar"></i> {{activeStores}} Lojas Ativas
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-3 col-sm-6">
                <div class="card">
                    <div class="card-content">
                        <div class="row">
                            <div class="col-xs-12">
                                <div class="numbers" style="text-align: left;">
                                    <p>Teste -> Cliente (<b>{{totalTrialsThisMonth}} -> {{totalClientsThisMonth}}</b>)
                                    </p>
                                    <span *ngIf="conversionTestClientThisMonth < 20" style="color:red">
                                        {{ conversionTestClientThisMonth | number:'.2-2'}}%</span>
                                    <span
                                        *ngIf="conversionTestClientThisMonth >= 20 && conversionTestClientThisMonth < 30"
                                        style="color:orange"> {{ conversionTestClientThisMonth | number:'.2-2'}}%</span>
                                    <span *ngIf="conversionTestClientThisMonth >= 30" style="color:green">
                                        {{ conversionTestClientThisMonth | number:'.2-2'}}%</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card-footer">
                        <div class="stats">
                            Mês passado: <span
                                style="color:black">{{conversionTestClientLastMonth | number:'.2-2'}}%</span> <span
                                style="float:right">{{totalTrialsLastMonth}} -> {{totalClientsLastMonth}}</span>
                            Mês retrasado: <span
                                style="color:black">{{conversionTestClient2MonthAgo | number:'.2-2'}}%</span> <span
                                style="float:right">{{totalTrials2MonthAgo}} -> {{totalClients2MonthAgo}}</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-3 col-sm-6">
                <div class="card">
                    <div class="card-content">
                        <div class="row">                            
                            <div class="col-xs-12">
                                <div class="numbers">
                                    <div class="stats" style="    font-size: 11px;">
                                        <i class="ti-timer"></i> ({{trialActiveStores}} ativas)
                                    </div>
                                    <p>Em Teste Grátis</p>
                                    {{ trialStores}}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card-footer">
                        <hr style="margin-bottom: 4px;" />
                        <div  class="stats">
                            <p style="font-size: 13px;">Free NuvemShop</p>
                                    <ul>
                                        <li>Nuvem Install: {{ nuvemShopInstalls}}</li>
                                        <li>Plano Grátis: {{ freeStores}}</li>
                                        <li>Com Recarga: {{ freePaidStores}}</li>
                                    </ul>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-3 col-sm-6">
                <div class="card">
                    <div class="card-content">
                        <div class="row">
                            <div class="col-xs-5">
                                <div class="icon-big icon-warning text-center">
                                    <i class="ti-server"></i>
                                </div>
                            </div>
                            <div class="col-xs-7">
                                <div class="numbers">
                                    <p>Total Lojas</p>
                                    {{ totalStores}}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card-footer">
                        <hr />
                        <div class="stats">
                            <i class="ti-reload"></i> ({{notActiveStores}} inativas)
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row" *ngIf="!tagModeOn">
            <div class="col-lg-2">
                <div id="acordeon" *ngIf="ticket != null">
                    <div class="panel-group" id="accordion">
                        <div class="panel panel-border panel-default"
                            [ngStyle]="{'background-color': ticket.problemStoreColor}">
                            <div data-toggle="collapse" href="#collapseOne" class="collapsed" aria-expanded="false">
                                <div class="panel-heading" style="background: #d9534f10;">
                                    <h4 class="panel-title">
                                        <a href="/#/admin/problemas">
                                            {{ticket.problemStoreIcon}} &nbsp; {{ticket.problemStores}} erros</a>
                                    </h4>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-10">
                <div id="acordeon">
                    <div class="panel-group" id="accordion">
                        <div class="panel panel-border panel-default" [ngStyle]="{'background-color': colorProblems}">
                            <div data-toggle="collapse" href="#collapseOne" class="collapsed" aria-expanded="false">
                                <div class="panel-heading" style="background: #d9534f10;">
                                    <h4 class="panel-title">
                                        Lojas com Problemas <b>({{totalProblems}})</b>
                                        <i class="ti-angle-down"></i>
                                    </h4>
                                    <a style="float:right;margin-top: -23px;"
                                        href="https://storeapi.opolen.com.br/Api/excel/AdminLojasComProblema?token=ott"
                                        class="btn btn-sm btn-fill btn-success btn-wd"><span
                                            class="ti-download"></span>Excel</a>
                                </div>
                            </div>
                            <div id="collapseOne" class="panel-collapse collapse" aria-expanded="false"
                                style="height: 0px;">
                                <div class="panel-body">
                                    <div class="col-md-4">
                                        <div class="card">
                                            <div class="card-header">
                                                <h4 class="card-title" style="float:left">Sem API</h4>
                                            </div>
                                            <div class="card-content table-full-width">
                                                <table class="table table-striped">
                                                    <thead>
                                                        <tr>
                                                            <th>#</th>
                                                            <th>Loja</th>
                                                            <th>Plataforma</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr *ngFor="let store of noApi; let i = index"
                                                            [attr.data-index]="i">
                                                            <td>
                                                                <div (click)="showDetails(store)"><i
                                                                        class="fa fa-search"></i></div>
                                                                {{i+1}}
                                                            </td>
                                                            <td>{{ store.name}}</td>
                                                            <td>{{ store.platform}}</td>
                                                        </tr>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div class="card">
                                            <div class="card-header">
                                                <h4 class="card-title" style="float:left">Sem Script</h4>
                                            </div>
                                            <div class="card-content table-full-width">
                                                <table class="table table-striped">
                                                    <thead>
                                                        <tr>
                                                            <th>#</th>
                                                            <th>Loja</th>
                                                            <th>Plataforma</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr *ngFor="let store of noScript; let i = index"
                                                            [attr.data-index]="i">
                                                            <td>
                                                                <div (click)="showDetails(store)"><i
                                                                        class="fa fa-search"></i></div>
                                                                {{i+1}}
                                                            </td>
                                                            <td>{{ store.name}}</td>
                                                            <td>{{ store.platform}}</td>
                                                        </tr>
                                                </table>
                                            </div>
                                        </div>
                                        <div class="card">
                                            <div class="card-header">
                                                <h4 class="card-title" style="float:left">Ativos Ñ Pagantes</h4>
                                            </div>
                                            <div class="card-content table-full-width">
                                                <table class="table table-striped">
                                                    <thead>
                                                        <tr>
                                                            <th>#</th>
                                                            <th>Loja</th>
                                                            <th>Plataforma</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr *ngFor="let store of noPayerActive; let i = index"
                                                            [attr.data-index]="i">
                                                            <td>
                                                                <div (click)="showDetails(store)"><i
                                                                        class="fa fa-search"></i></div>
                                                                {{i+1}}
                                                            </td>
                                                            <td>{{ store.name}}</td>
                                                            <td>{{ store.platform}}</td>
                                                        </tr>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div class="card">
                                            <div class="card-header">
                                                <h4 class="card-title" style="float:left">Desativados</h4>
                                            </div>
                                            <div class="card-content table-full-width">
                                                <table class="table table-striped">
                                                    <thead>
                                                        <tr>
                                                            <th>#</th>
                                                            <th>Loja</th>
                                                            <th>Plataforma</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr *ngFor="let store of noActive; let i = index"
                                                            [attr.data-index]="i">
                                                            <td>
                                                                <div (click)="showDetails(store)"><i
                                                                        class="fa fa-search"></i></div>
                                                                {{i+1}}
                                                            </td>
                                                            <td>{{ store.name}}</td>
                                                            <td>{{ store.platform}}</td>
                                                        </tr>
                                                </table>
                                            </div>
                                        </div>
                                        <div class="card">
                                            <div class="card-header">
                                                <h4 class="card-title" style="float:left">Data de Renovação Zuado</h4>
                                            </div>
                                            <div class="card-content table-full-width">
                                                <table class="table table-striped">
                                                    <thead>
                                                        <tr>
                                                            <th>#</th>
                                                            <th>Loja</th>
                                                            <th>Plataforma</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr *ngFor="let store of nextInvoiceDateWrong; let i = index"
                                                            [attr.data-index]="i">
                                                            <td>
                                                                <div (click)="showDetails(store)"><i
                                                                        class="fa fa-search"></i></div>
                                                                {{i+1}}
                                                            </td>
                                                            <td>{{ store.name}}</td>
                                                            <td>{{ store.platform}}</td>
                                                        </tr>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header">
                        <h4 class="card-title" style="float:left">Lojas Polinizadoras 
                            <span *ngIf="tagModeOn"> - <b>Tag: {{filterTag}}</b></span>
                        </h4>
                        <a style="float:right" (click)="reallyLoadAll()" class="btn btn-sm btn-primary btn-wd">Carregar
                            Todos</a>
                        <a style="float:right"
                            href="https://storeapi.opolen.com.br/Api/Dashboard/AdminExcelBasicStores?token=ott"
                            class="btn btn-sm btn-success btn-wd"><span class="ti-download"></span> Download Excel</a>
                        <!-- <a style="float:right" href="http://storeapi.opolen.com.br/Api/Excel/AdminLeadLovers?token=ott" class="btn btn-sm btn-success btn-wd"><span class="ti-download"></span> LeadLovers Excel</a> -->
                        <a style="float:right"
                            href="https://storeapi.opolen.com.br/Api/Excel/AdminExcelStoreMetrics?token=ott"
                            class="btn btn-sm btn-success btn-wd"><span class="ti-download"></span> Metricas Excel</a>
                        <a style="float:right"
                            (click)="showTagContainer()"
                            class="btn btn-sm btn-success btn-wd"><span class="ti-plus"></span> Add Tag</a>
                        <a style="float:right"
                            (click)="showTagRemover()"
                            class="btn btn-sm btn-success btn-wd">- Remove Tag</a>
                        <div class="filter-container">
                            <select (change)="filterStores($event.target.value)" class="pull-left" style="margin:5px;">
                                <option value="all">Filtro Financeiro</option>
                                <option value="all">Todas</option>
                                <option value="payment">Pagantes</option>
                                <option value="active">Ativas</option>
                                <option value="trial">Teste Grátis</option>
                                <option value="freePaid">Plano Grátis Pagante</option>
                                <option value="inactive">Inativas</option>
                                <option value="churn">Churn</option>
                                <option value="upsell">UpSell</option>
                                <option value="renewal">Renovação este mês</option>
                            </select>
                            <select (change)="filterPlanStores($event.target.value)" class="pull-left"
                                style="margin: 5px;">
                                <option value="all">Filtro por planos</option>
                                <option value="all">Todos</option>
                                <option value="trial">Trial</option>
                                <option value="free">Plano Grátis</option>
                                <option value="start">Start</option>
                                <option value="flower-1">Flower-1</option>
                                <option value="flower-2">Flower-2</option>
                                <option value="flower-3">Flower-3</option>
                                <option value="flower-4">Flower-4</option>
                                <option value="bloomer-1">Bloomer-1</option>
                                <option value="bloomer-2">Bloomer-2</option>
                                <option value="bloomer-3">Bloomer-3</option>
                                <option value="bloomer-4">Bloomer-4</option>
                                <option value="bloomer-5">Bloomer-5</option>
                                <option value="bloomer-6">Bloomer-6</option>
                                <option value="bloomer-7">Bloomer-7</option>
                                <option value="enterprise">Enterprise</option>
                                <option value="percentual">Percentual</option>
                                <option value="no-plan">Sem Plano</option>
                            </select>
                            <select (change)="filterPerProduct($event.target.value)" class="pull-left"
                                style="margin: 5px;">
                                <option value="all">Filtro por Produto</option>
                                <option value="all">Todos</option>
                                <option value="bomtroco">Bom Troco</option>
                                <option value="1compra1doacao">1compra1doacao</option>
                            </select>
                            <select (change)="filterPlataform($event.target.value)" class="pull-left"
                                style="margin: 5px;">
                                <option value="all">Filtro por Plataforma</option>
                                <option value="all">Todos</option>
                                <option value="Loja Integrada">Loja Integrada</option>
                                <option value="NuvemShop">NuvemShop</option>
                                <option value="CartX">CartX</option>
                                <option value="Tray">Tray</option>
                                <option value="Bagy">Bagy</option>
                                <option value="Menu Integrado">Menu Integrado</option>
                                <option value="VTEX">VTEX</option>
                                <option value="Shopify">Shopify</option>
                                <option value="Magento">Magento</option>
                                <option value="Betalabs">Betalabs</option>
                                <option value="Iluria">Iluria</option>
                                <option value="XTECH ">XTECH </option>
                                <option value="wBuy">wBuy</option>
                                <option value="WooCommerce">WooCommerce</option>
                                <option value="WIX">WIX</option>
                                <option value="Irroba">Irroba</option>
                                <option value="Yampi"> Yampi</option>
                                <option value="Tray Corp - Fbits">Tray Corp - Fbits</option>
                                <option value="Vnda">Vnda</option>
                                <option value="Magazord">Magazord</option>
                                <option value="iSet">iSet</option>
                                <option value="Convertize">Convertize</option>
                                <option value="Jet">Jet</option>
                                <option value="Vnda">Vnda</option>
                                <option value="Campanha de Doação">Campanha de Doação</option>
                                <option value="independente">Independente</option>
                            </select>
                            <div style="display: none">
                                <div (click)="filterStores('all')" class="pull-left"><span class="label label-info">
                                        Todas
                                    </span></div>
                                <div (click)="filterStores('payment')" class="pull-left"><span
                                        class="label label-success">
                                        Pagantes
                                    </span></div>
                                <div (click)="filterStores('active')" class="pull-left"><span class="label label-info">
                                        Ativos
                                    </span></div>
                                <div (click)="filterStores('trial')" class="pull-left"><span
                                        class="label label-warning">
                                        Teste Grátis
                                    </span></div>
                                <div (click)="filterStores('inactive')" class="pull-left"><span
                                        class="label label-danger">
                                        Inativas
                                    </span></div>
                                <div (click)="filterStores('churn')" class="pull-left"><span class="label label-danger">
                                        Churn
                                    </span></div>
                                <div (click)="filterStores('upsell')" class="pull-left"><span
                                        class="label label-warning">
                                        UpSell
                                    </span></div>
                                <div (click)="filterStores('renewal')" class="pull-left"><span
                                        class="label label-success">
                                        Renovação este mês
                                    </span></div>
                            </div>
                        </div>
                        <div class="search-container">
                           <span>Buscar:</span>                                
                                <input class="form-control" type="text" placeholder="Pesquise aqui! de Enter"
                                    (change)="filterByName()" name="byname" [(ngModel)]="storeFilter.byname" required
                                    #byname="ngModel">
                            
                        </div>
                        <div *ngIf="!tagModeOn" class="tag-container">
                            Tags:
                            <ng-container *ngFor="let tag of tags; let i = index" [attr.data-index]="i">
                                <a target="_blank" href="/#/dashboard/store?tag={{tag}}" class="label label-info">{{ tag}}</a>&nbsp;
                            </ng-container>
                        </div>
                    </div>
                    <div class="card-content table-full-width">
                        <table class="table table-striped">
                            <thead>
                                <tr>
                                    <th></th>
                                    <th>Data</th>
                                    <th style="width: 200px;max-width: 200px;overflow-y: hidden;">Site</th>
                                    <th style="width: 150px">Email</th>
                                    <th>Plan</th>
                                    <th>Plataforma</th>
                                    <th style="width:150px">Causas</th>
                                    <th>Ativo</th>
                                    <th class="text-right" style="width:150px">Ações</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let store of stores  | paginate: { itemsPerPage: 50, currentPage: paginaAtual }; let i = index" [attr.data-index]="i"
                                    [hidden]="!store.filterShow">
                                    <td>
                                        <div (click)="showDetails(store)"><i class="fa fa-search"></i></div>
                                        {{i+1}}
                                    </td>
                                    <td>{{ store.registrationDate | date:'dd/MM/yyyy'}}</td>
                                    <td style="width: 200px;max-width: 200px; overflow-y: hidden;">
                                        <div *ngIf="store.upSell != null"><span
                                                class="label label-info">{{ store.upSell }}</span><br></div>
                                        <div *ngIf="store.trialActive"><span
                                                class="label label-warning">trial</span><br></div>
                                        <div *ngIf="store.churn"><span class="label label-danger">churn</span><br></div>
                                        <div *ngIf="store.activePayingUser"><span
                                                class="label label-success">Pagantes</span><br></div>
                                        <ng-container *ngIf="store.tags != null">
                                            <div *ngFor="let tag of store.tags; let i = index" (click)="removeTag(tag,store.seoUrl)"
                                                class="label label-success" style="background-color: #1d89f6; cursor: pointer;">
                                                {{tag}} -
                                            </div>
                                        </ng-container>
                                        <div *ngIf="store.renewalThisMonth"><span
                                                class="label label-success">Renovação!!!</span><br></div>
                                        <div *ngIf="store.activePayingUser && store.billingIdentifier == null"><span
                                                class="label label-warning">sem cnpj/cpf</span><br></div>
                                        <div *ngIf="store.activePayingUser && store.billingZipCode == null"><span
                                                class="label label-warning">sem CEP</span><br></div>
                                        <div><span class="label label-success">{{ store.productLabel }}</span><br></div>
                                        <a href="{{store.mainDomain}}" target="_blank"
                                            title="{{store.mainDomain }}">{{store.name}}</a>
                                    </td>
                                    <td>
                                        <div style="width: 150px; overflow-y: hidden;">{{store.email}}</div>
                                    </td>
                                    <td>
                                        <div style="width: 50px; overflow-y: hidden;">{{store.planName}}</div>
                                    </td>
                                    <td>{{store.platform}}</td>
                                    <td style="width:150px">
                                        <div style="display:flex; flex-direction: row;    max-height: 50px;width:160px">
                                            <img *ngFor="let ngo of store.ngoLogoUrls; let i = index"
                                                [attr.data-index]="i" src="{{ngo.value}}" title="{{ngo.key}}"
                                                style="max-width:50px; float:left; padding:2px;margin:2px; border:1px solid #c2c2c2" />
                                        </div>
                                    </td>
                                    <td class="text-right">
                                        <table>
                                            <tr>
                                                <td>
                                                    <img *ngIf="store.hasPolenScript" style="width:25px"
                                                        title="Script instalado!"
                                                        src="https://storage.googleapis.com/sealpolen-files.polinizador.com.br/images/icones/checked.png" />
                                                    <img *ngIf="!store.hasPolenScript"
                                                        style="width:25px; cursor:pointer"
                                                        (click)="lookforScript(store)" title="Script não encontrado!"
                                                        src="https://cdn.iconscout.com/icon/premium/png-256-thumb/cancel-251-754627.png" />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <img *ngIf="store.active" style="width:25px" title="Polen Ativo!"
                                                        src="https://storage.googleapis.com/sealpolen-files.polinizador.com.br/images/icones/checked.png" />
                                                    <img *ngIf="!store.active" style="width:25px; "
                                                        title="Polen ñ está ativo!"
                                                        src="https://cdn.iconscout.com/icon/premium/png-256-thumb/cancel-251-754627.png" />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <img *ngIf="store.activePayingUser" style="width:25px"
                                                        title="Cliente Pagante!"
                                                        src="https://storage.googleapis.com/sealpolen-files.polinizador.com.br/images/icones/checked.png" />
                                                    <img *ngIf="!store.activePayingUser" style="width:25px;"
                                                        title="Cliente ñ pagante!"
                                                        src="https://cdn.iconscout.com/icon/premium/png-256-thumb/cancel-251-754627.png" />
                                                </td>
                                            </tr>
                                        </table>
                                    </td>
                                    <td class="td-actions text-right">
                                        <button (click)="editStore(store)" class="btn btn-sm">Editar</button>&nbsp;
                                        <div *ngIf="store.trialActive && store.daysTrialLeft >= 2"><span
                                                class="label label-warning">
                                                Restam {{ store.daysTrialLeft}} dias </span></div>
                                        <div *ngIf="store.trialActive && store.daysTrialLeft < 2"><span
                                                class="label label-danger">
                                                Restam {{ store.daysTrialLeft}} dias </span></div>
                                        <a href="https://api.opolen.com.br/api/helper/ClearCacheStore?storeName={{store.seoUrl}}"
                                            target="_blank" class="btn btn-warning btn-sm">Limpar Cache</a>&nbsp;
                                        <!-- <button class="btn btn-sm">Analytics</button> -->
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <div style="font-size: 2.5rem; text-align: center;">
                            <pagination-controls (pageChange)="paginaAtual = $event" previousLabel="Anterior" nextLabel="Próximo" autoHide="true" ></pagination-controls>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

    
<ngx-smart-modal #storeModal identifier="tagModal" customClass="small-modal">
    <h3>Adicionar Nova Tag</h3>
    <table *ngIf="tagEditor != null" style="width: 100%;">
        <tr>
            <td>Id da Tag</td>
            <td>
                <div class="col-lg-5 col-sm-5">
                    <input class="form-control" type="text" name="tagCode"
                    [(ngModel)]="tagEditor.tagCode" required #tagName="ngModel" />
                    <small>(sem espaço e caracteres especiais)</small>
                </div>
            </td>
        </tr>
        <tr>
            <td>Nome da Tag</td>
            <td>
                <div class="col-lg-5 col-sm-5">
                    <input class="form-control" type="text" name="tagName"
                    [(ngModel)]="tagEditor.tagName" required #tagName="ngModel" />
                    <small>(ñ é exibida atualmente)</small>
                </div>
            </td>
        </tr>
        <tr>
            <td>Empresas com a Tag</td>
            <td>
                <div class="col-lg-5 col-sm-5">
                    <input class="form-control" type="text" name="storeUrls"
                    [(ngModel)]="tagEditor.storeUrls" required #storeUrls="ngModel" />
                    <small>(adicione o SeoUrl separado por vírgula SEM ESPAÇOS)</small>
                </div>
            </td>
        </tr>
        <tr>
            
            <td colspan="2">
                <button style="float:right" type="button" (click)="addTag()"
                    class="btn btn-info">Adicionar Tag</button>
            </td>
        </tr>
    </table>
</ngx-smart-modal>

<ngx-smart-modal #storeModal1 identifier="removeTag" customClass="small-modal">
    <h3>Remover tag das lojas</h3>
    <table *ngIf="tagEditor != null" style="width: 100%;">
        <tr>
            <td>Id da Tag</td>
            <td>
                <div class="col-lg-5 col-sm-5">
                    <input class="form-control" type="text" name="tagCode"
                    [(ngModel)]="tagEditor.tagCode" required #tagName="ngModel" />
                    <small>(sem espaço e caracteres especiais)</small>
                </div>
            </td>
        </tr>
        <tr>
            <td>Empresas com a Tag</td>
            <td>
                <div class="col-lg-5 col-sm-5">
                    <input class="form-control" type="text" name="storeUrls"
                    [(ngModel)]="tagEditor.storeUrls" required #storeUrls="ngModel" />
                    <small>(adicione o SeoUrl separado por vírgula SEM ESPAÇOS)</small>
                </div>
            </td>
        </tr>
        <tr>
            <td colspan="2">
                <button style="float:right" type="button" (click)="removeComboTag()"
                    class="btn btn-info">Remover Tag</button>
            </td>
        </tr>
    </table>
</ngx-smart-modal>

<ngx-smart-modal #storeModal2 identifier="storeModal" customClass="small-modal">
    <div *ngIf="storeEdit">
        <h4 style="float: left;" class="card-title">Editar Status Loja</h4>
        <div style="float: right;margin-top: 20px;">
            <button class="btn btn-warning" type="button" (click)="newTicket(storeEdit.seoUrl)">
                <img src="https://files.polen.app.br/images/icones/hubspot-icon.jpg"
                    style="width: 20px; cursor: pointer;" /> Novo Ticket</button>
        </div>
        <form #f2="ngForm" class="form-horizontal" novalidate (ngSubmit)="save2(f2.value, f2.valid)">
            <table class="table table-striped">
                <tbody>
                    <tr>
                        <td>Nome</td>
                        <td>{{ storeEdit.name}}</td>
                    </tr>
                    <tr>
                        <td>SeoUrl</td>
                        <td>{{ storeEdit.seoUrl}}</td>
                    </tr>
                    <tr>
                        <td>ApiKey</td>
                        <td>{{ storeEdit.apiKey}}</td>
                    </tr>
                    <tr>
                        <td>Plataforma</td>
                        <td>{{ storeEdit.platformName}}</td>
                    </tr>
                    <tr>
                        <td>Domínio</td>
                        <td>{{ storeEdit.domain }}</td>
                    </tr>
                    <tr>
                        <td>Phone</td>
                        <td *ngIf="storeEdit.lead">{{ storeEdit.lead.phone }}</td>
                        <td *ngIf="!storeEdit.lead">-</td>
                    </tr>
                    <tr>
                        <td>Categoria</td>
                        <td>
                            <div class="col-lg-5 col-sm-5">
                                <select class="form-control ng-untouched ng-pristine ng-valid"
                                    [(ngModel)]="storeEdit.category" #category="ngModel" name="category">
                                    <option value="">Selecione a categoria do E-commerce</option>
                                    <option *ngFor="let c of listcategories" value="{{c.id}}">{{c.name}}</option>
                                </select>
                            </div>
                            <button style="float:right" type="button" (click)="updateCategory(storeEdit)"
                                class="btn btn-info">Salvar Categoria</button>
                        </td>
                    </tr>
                    <tr>
                        <td>Nº de pedidos no mês</td>
                        <td>{{ storeEdit.salesAmountDescription}}</td>
                    </tr>
                    <tr>
                        <td>Teste Ativo</td>
                        <td>
                            <label class="switch">
                                <input type="checkbox" name="trialActive" [checked]="storeEdit.trialActive"
                                    (change)="storeEdit.trialActive = !storeEdit.trialActive">
                                <span class="slider round"></span>
                            </label>
                            <button style="float:right" type="button" (click)="sendEmailStartTrial(storeEdit)"
                                class="btn btn-info">Iniciar
                                Teste</button>
                        </td>
                    </tr>
                    <tr>
                        <td>Inicio do Trial</td>
                        <td>
                            <input class="form-control" type="text" name="trialActivationDate"
                                [(ngModel)]="storeEdit.trialActivationDate" required #trialActivationDate="ngModel">
                    </tr>
                    <tr>
                        <td>Fim do Trial</td>
                        <td>
                            <input class="form-control" type="text" name="trialEndDate"
                                [(ngModel)]="storeEdit.trialEndDate" required #trialEndDate="ngModel">
                        </td>
                    </tr>
                    <tr>
                        <td>Script Ativo</td>
                        <td>
                            <label class="switch">
                                <input type="checkbox" name="scriptValidated" [checked]="storeEdit.scriptValidated"
                                    (change)="storeEdit.scriptValidated = !storeEdit.scriptValidated">
                                <span class="slider round"></span>
                            </label>
                        </td>
                    </tr>
                    <tr>
                        <td>Ativo</td>
                        <td>
                            <label class="switch">
                                <input type="checkbox" name="active" [checked]="storeEdit.active"
                                    (change)="storeEdit.active = !storeEdit.active">
                                <span class="slider round"></span>
                            </label>
                        </td>
                    </tr>
                    <tr>
                        <td>Teste de Desenvolvimento</td>
                        <td>
                            <label class="switch">
                                <input type="checkbox" name="developmentTest" [checked]="storeEdit.developmentTest"
                                    (change)="storeEdit.developmentTest = !storeEdit.developmentTest">
                                <span class="slider round"></span>
                            </label>
                        </td>
                    </tr>
                    <tr>
                        <td>Cliente Pagante</td>
                        <td>
                            <label class="switch">
                                <input type="checkbox" name="activePayingUser"
                                    [checked]="storeEdit.activePayingUser"
                                    (change)="storeEdit.activePayingUser = !storeEdit.activePayingUser">
                                <span class="slider round"></span>
                            </label>
                        </td>
                    </tr>
                    <tr>
                        <td colspan="2">
                            <div class="container-fluid">
                                <div class="row">
                                    <div class="col-lg-6 col-sm-6">
                                        Cupom: <input class="form-control" type="text" name="couponCode"
                                            [(ngModel)]="storeEdit.couponCode" required #couponCode="ngModel" />
                                    </div>
                                    <div class="col-lg-6 col-sm-6">
                                        ReferralCode: <input class="form-control" type="text" name="referralCode"
                                            [(ngModel)]="storeEdit.referralCode" required #referralCode="ngModel" />
                                    </div>
                                </div>
                            </div>
                            <br>
                        </td>
                    </tr>
                    <tr>
                        <td colspan="2">
                            <div class="container-fluid">
                                <div class="row">
                                    <div class="col-lg-5 col-sm-5">
                                        Compras nos últimos 30 dias: <input class="form-control" type="text"
                                            name="countLastMonthSales" [(ngModel)]="storeEdit.countLastMonthSales"
                                            required #countLastMonthSales="ngModel" />
                                    </div>
                                    <div class="col-lg-5 col-sm-5">
                                        Compras até o dia: <input class="form-control" type="text"
                                            name="dateCountLastMonthSales"
                                            [(ngModel)]="storeEdit.dateCountLastMonthSales" required
                                            #dateCountLastMonthSales="ngModel" />
                                    </div>
                                    <div class="col-lg-2 col-sm-2">
                                        <button style="float:right" type="button"
                                            (click)="updateCountLastMonthSales(storeEdit.seoUrl)"
                                            class="btn btn-info">Atualizar</button>
                                    </div>
                                </div>
                            </div>
                            <br>
                        </td>
                    </tr>
                    <tr>
                        <td>Churn?</td>
                        <td>
                            <label class="switch">
                                <input type="checkbox" name="churn" [checked]="storeEdit.churn"
                                    (change)="storeEdit.churn = !storeEdit.churn">
                                <span class="slider round"></span>
                            </label>
                        </td>
                    </tr>
                    <tr>
                        <td>Churn Date?</td>
                        <td>
                            <input class="form-control" type="text" name="churnDate"
                                [(ngModel)]="storeEdit.churnDate" required #churnDate="ngModel" />
                        </td>
                    </tr>
                    <tr>
                        <td>Últimos Pagamentos</td>
                        <td>
                            <div class="row">
                                <div class="col-lg-9 col-sm-9">
                                    <b>Último Pagamento:</b> {{ storeEdit.lastPaidDate | date:'dd/MM/yyyy'}}
                                    <br>
                                    <b>Próximo Renovação:</b> {{ storeEdit.nextInvoiceDate | date:'dd/MM/yyyy'}}
                                </div>
                                <div class="col-lg-3 col-sm-3">
                                    <button style="float:right" type="button"
                                        (click)="updateLastPaidDate(storeEdit)"
                                        class="btn btn-sm btn-info">Atualizar Renovações</button>
                                </div>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td>MRR</td>
                        <td>
                            <div class="row">
                                <div class="col-lg-9 col-sm-9">
                                    <b>R$ {{ storeEdit.mrr }}</b>
                                </div>
                                <div class="col-lg-3 col-sm-3">
                                    <button style="float:right" type="button" (click)="updateMrr(storeEdit)"
                                        class="btn btn-sm btn-info">Atualizar MRR</button>
                                </div>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </form>
        <button type="button" (click)="updateStatusStore(storeEdit)" class="btn btn-info">Atualizar Status da {{
      storeEdit.name}}</button>
    </div>
</ngx-smart-modal>